/// <amd-module name="Widgets/Burndown/BurndownWidgetComponents/BurnDirection" />
export enum BurnDirection {
    Down,
    Up
}
